// 📁 api/crm/customers/info.js
import axiosInstance from "../../axiosInstance";
const BASE_URL = "/crm/customers";

// 🔍 Lấy danh sách khách hàng (có lọc)
export const getAllCustomers = async (params = {}) => {
  try {
    const response = await axiosInstance.get(BASE_URL, { params });
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy danh sách khách hàng:", error);
    throw error;
  }
};

// 🔍 Lấy danh sách khách hàng gọn nhẹ (id, name, ward)
export const getSimpleCustomers = async (params = {}) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/simple`,
      { params, skipGlobalErrorToast: true }
    );

    return response.data;

  } catch (error) {
    console.error("❌ Lỗi khi lấy danh sách khách hàng (simple):", error);
    return { items: [] };
  }
};

// 🔍 Lấy thông tin 1 khách hàng
export const getCustomerById = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/${id}`);
  return response.data;
};

// ➕ Thêm khách hàng
export const createCustomer = async (data) => {
  try {
    const response = await axiosInstance.post(BASE_URL, data);

    // chuẩn hóa format trả về
    return {
      success: true,
      ...response.data,
    };

  } catch (error) {
    console.error("❌ Lỗi createCustomer:", error);

    // lấy message từ BE nếu có
    const message =
      error?.response?.data?.message || "Lỗi kết nối server";

    return {
      success: false,
      message,
    };
  }
};


// ✏️ Cập nhật khách hàng
export const updateCustomer = async (id, data) => {
  const response = await axiosInstance.put(`${BASE_URL}/${id}`, data);
  return response.data;
};

// ❌ Xoá khách hàng
export const deleteCustomer = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return response.data;
};

// 📌 Lấy danh sách khách hàng theo chi nhánh
export const getCustomersByBranch = async (branchId) => {
  const res = await axiosInstance.get(`${BASE_URL}/by-branch/${branchId}`);
  return res.data;
};

// 📌 Lấy Quận/Huyện theo chi nhánh
export const getDistrictsByBranch = async (branchId) => {
  const response = await axiosInstance.get(`${BASE_URL}/districts`, {
    params: { branch_id: branchId },
  });
  return response.data;
};

// 📌 Lấy Phường/Xã theo chi nhánh
export const getWardsByBranch = async (branchId) => {
  const response = await axiosInstance.get(`${BASE_URL}/wards`, {
    params: { branch_id: branchId },
  });
  return response.data;
};

// 📌 Lấy Trạng thái theo chi nhánh
export const getStatusesByBranch = async (branchId) => {
  const response = await axiosInstance.get(`${BASE_URL}/statuses`, {
    params: { branch_id: branchId },
  });
  return response.data;
};

// 📊 Thống kê mini dashboard (cùng bộ lọc + data_scope với danh sách)
export const getCustomerStats = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/stats`, { params });
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy thống kê khách hàng:", error);
    throw error;
  }
};

// 📌 Lấy options filter khách hàng từ crm.customer_info
export const getCustomerFilterOptions = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/filter-options`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy options bộ lọc khách hàng:", error);
    throw error;
  }
};

// 📥 Import khách hàng từ Excel/CSV
export const importCustomers = async (file, branchId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("branch_id", branchId);

  const response = await axiosInstance.post(`${BASE_URL}/import`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};
